<template>
	<div class="gist">
		<div class="container">
			<div class="noinfo">
				<span>Топ 20 каналов</span>
				<span>Отсутствует информация</span>
			</div>
			<div id="chartContainer_rating"></div>
		</div>
		<div class="container">
			<p @click="modal">i</p>
			<div class="noinfo">
				<span>Сыпуха каналов за сутки.</span>
				<span>Отсутствует информация</span>
			</div>
			<div id="chartContainer_day"></div>
		</div>
	</div>
</template>
<script>
	import { performRequest }           from "../script/ws/wsclient";
	import { mapMutations, mapGetters } from "vuex";

	export default {
		name:       "Gist",
		components: {},
		mounted() {
			( () => {
				let opeator   = this.getViewUser;
				let command   = {};
				let data      = {};
				let chartList = {};

				function onResponse(a, val) {
					let json = [];
					let tmp  = [];
					let t;

					a.data.forEach(item => {
						t       = {};
						t.label = item.stream;
						t.y     = item["leak_count"];
						tmp.push(t);
					});

					tmp.forEach(item => {
						if (item.y >= 5) {
							json.push(item);
						}
					});
					chartList[val].options.data[0].dataPoints = json;
					chartList[val].render();
				}

				function initGraph() {
					let chart;

					chart         = new CanvasJS.Chart("chartContainer_day", {
						zoomEnabled:     true,
						exportEnabled:   true,
						backgroundColor: "rgb(184, 200, 209)",
						theme:           "light2",
						width:           630,
						height:          280,
						title:           {
							text:     "Сыпуха каналов за сутки",
							fontSize: 14
						},
						axisX:           {
							labelAutoFit: false,
							labelAngle:   -45,
							interval:     1
						},
						axisY:           {
							title: ""
						},
						data:            [
							{
								type:         "column",
								bevelEnabled: true,
								indexLabel:   "{y}",
								dataPoints:   null
							}
						]
					});
					chart.name    = "day";
					chartList.day = chart;
				}

				function gistG(val, text) {
					command.section = "iptvlog";
					command.name    = text;
					data.dateTo     = Math.floor(Date.now() / 1000);
					data.dateFrom   = Math.floor(Date.now() / 1000) - 60 * 60 * 24;
					data.operator   = opeator;
					performRequest(command, data, a => {
						onResponse(a, val);
					});
				}

				initGraph();
				gistG("day", "getStreamLeak");
			} )();
			( () => {
				let operator  = this.getViewUser;
				let command   = {};
				let data      = {};
				let chartList = {};
				let maxTime   = 0;

				function onResponse(a, val) {
					let json = [];

					let tmp = [];
					let t;
					a.data.forEach(item => {
						t       = {};
						t.label = item.stream;
						t.y     = item.duration;
						tmp.push(t);
					});

					tmp.forEach(item => {
						maxTime += item.y;
					});

					tmp.forEach(item => {
						item.y = Math.round(item.y * 100 / maxTime);
						if (item.y > 0) {
							if (json.length >= 20) {
								return;
							}
							json.push(item);
						}
					});
					chartList[val].options.data[0].dataPoints = json;
					chartList[val].render();
				}

				function initGraph() {
					let chart;
					chart            = new CanvasJS.Chart("chartContainer_rating", {
						zoomEnabled:     true,
						exportEnabled:   true,
						backgroundColor: "rgb(184, 200, 209)",
						theme:           "light2",
						width:           630,
						height:          280,
						title:           {
							text:     "Top 20 телеканалов",
							fontSize: 14
						},
						axisX:           {
							labelAutoFit: false,
							labelAngle:   -45,
							interval:     1
						},
						axisY:           {
							title: "рейтинг, %"
						},
						data:            [
							{
								type:         "column",
								bevelEnabled: true,
								indexLabel:   "{y}",
								dataPoints:   null
							}
						]
					});
					chart.name       = "rating";
					chartList.rating = chart;
				}

				function gistG(val, text) {
					command.section = "iptvlog";
					command.name    = text;
					data.dateTo     = Math.floor(Date.now() / 1000);
					data.dateFrom   = Math.floor(Date.now() / 1000) - 60 * 60 * 24;
					data.operator   = operator;
					performRequest(command, data, a => {
						onResponse(a, val);
					});
				}

				initGraph();
				gistG("rating", "getStreamRaiting");
			} )();
		},
		computed:   {
			...mapGetters(["getChartContainerDay", "getViewUser"])
		},
		methods:    {
			...mapMutations(["setChartContainerDay"]),
			modal() {
				this.setChartContainerDay(!this.getChartContainerDay);
			}
		}
	};
</script>
<style scoped lang="scss">
	.gist {
		position: relative;
		display: flex;
		justify-content: center;
		flex-wrap: wrap;
		margin: auto;
		align-content: flex-start;
		
		div {
			width: 45rem;
			height: 20rem;
			box-shadow: 0 0 5px #909090;
			background-color: rgba(184, 117, 209, 0.15);
		}
		
		div {
			width: 45rem;
			height: 20rem;
		}
		
		canvas {
			width: 45rem;
			height: 20rem;
			border-radius: 5px;
			opacity: 0.2;
		}
		
		#chartContainer_rating, #chartContainer_day {
			font-size: 12px;
			min-width: 45rem;
			min-height: 20rem;
		}
		
		.container {
			position: relative;
			padding: 0;
			margin: 0.5rem;
			
			p {
				position: absolute;
				z-index: 1000;
				width: 3rem;
				height: 3rem;
				border-radius: 50%;
				background-color: rgb(142, 255, 153);
				cursor: pointer;
				opacity: 0;
				left: -1rem;
				top: -1rem;
				font-weight: bold;
				text-align: center;
				line-height: 2.9rem;
				font-size: 3rem;
				box-shadow: 0 0 1rem #000, inset 0 0 3px #000;
				animation: pulse 1s ease infinite;
				transition: opacity 0.5s;
			}
			.noinfo {
				position: absolute;
				width: 45rem;
				height: 20rem;
				display: flex;
				flex-direction: column;
				justify-content: center;
				span {
					height: 30px;
					font-size: 1.2rem;
					text-align: center;
				}
			}
			
			&:hover > p {
				opacity: 1;
			}
			
			@keyframes pulse {
				0% {
					transform: scale(1);
				}
				
				50% {
					transform: scale(1.1);
				}
				
				100% {
					transform: scale(1);
				}
			}
		}
	}
	@media (min-width: 1200px) {
		.gist {
			width: 98%;
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/Gist.vue